"use strict";

exports.__esModule = true;
exports.isDate = isDate;

var _number = require("./number");

function isDate(val) {
  return Object.prototype.toString.call(val) === '[object Date]' && !(0, _number.isNaN)(val.getTime());
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/utils/validate/date.js
// module id = 173
// module chunks = 1